var map = {
	"./directives/templates/addFriends.html": 82,
	"./directives/templates/chatAbuseReport.html": 83,
	"./directives/templates/chatBar.html": 84,
	"./directives/templates/chatBase.html": 85,
	"./directives/templates/chatDialog.html": 86,
	"./directives/templates/chatGroupDialog.html": 87,
	"./directives/templates/chatPlaceholder.html": 88,
	"./directives/templates/confirmNegativeAction.html": 89,
	"./directives/templates/conversationTitle.html": 90,
	"./directives/templates/conversationTitleEditor.html": 91,
	"./directives/templates/createChatGroup.html": 92,
	"./directives/templates/details.html": 93,
	"./directives/templates/dialogHeader.html": 94,
	"./directives/templates/dialogMinimize.html": 95,
	"./directives/templates/displayMessage.html": 96,
	"./directives/templates/gamesList.html": 97,
	"./directives/templates/linkCard.html": 98,
	"./directives/templates/selectFriends.html": 99,
	"./directives/templates/systemMessage.html": 100,
	"./directives/templates/userConversationInfo.html": 101
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81;